import axios from "../plugins/axios.js";

class funcoesUsuarioService {
  async getFuncoes(role, usuario, idInstituicao) {
    try {
      const response = await axios.get(`/carregarFuncoes/${role}/${usuario}/${idInstituicao}`);
      if (response.status == 200) {
        if (response.data.length > 0) {
          return response.data;
        } else {
          return null;
        }
      }
    } catch (error) {
      return 500;
    }
  }

  async getFuncoesByMenu() {
    try {
      let response = await axios.get("/carregarFuncoesPorMenu").then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error, "Erro na funcoesUsuarioService.getFuncoesByMenu()");
    }
  }

  async getFuncoesMenu(idMenu) {
    try {
      let response = await axios.get(`/carregarFuncoesMenu/${idMenu}`).then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error, "Erro na funcoesUsuarioService.getFuncoesMenu()");
    }
  }

  async getPermissoesUsuarios() {
    try {
      let response = await axios.get("/carregarPermissoesPed").then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error,"Erro na funcoesUsuarioService.getPermissoesUsuarios()");
    }
  }

  async getUsuarios(instituicao) {
    try {
      let response = await axios
        .get(`/carregarUsuarios/${instituicao}`)
        .then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error, "Erro na funcoesUsuarioService.getUsuarios()");
    }
  }

  async getExcecoesFuncoes(funcaoId, instituicao) {
    try {
      let response = await axios
        .get(`/carregarFuncoesExceccoes/${funcaoId}/${instituicao}`)
        .then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error, "Erro na funcoesUsuarioService.getExcecoesFuncoes()");
    }
  }

 

  async getAllFunctions(pkUsuario, nivel) {
    try {
      let response = await axios
        .get(`/carregarFuncoesAll/${nivel}/${pkUsuario}`)
        .then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error, "Erro na funcoesUsuarioService.getAllFunctions()");
    }
  }

  async updateFunction(payload) {
    try {
      let response = await axios
        .post("/updateFuncao", payload)
        .then((res) => res);
      if (response.status == 200 && response.data.affectedRows >= 1) {
        return 200;
      } else {
        return 500;
      }
    } catch (error) {
      return 500;
    }
  }

  async updatePermissoes(payload) {
    try {
      let response = await axios
        .post("/updatePermissoes", payload)
        .then((res) => res);
      if (response.status == 200) {
        return 200;
      } else {
        return 500;
      }
    } catch (error) {
      return 500;
    }
  }

  async createExcecoes(payload) {
    try {
      let response = await axios
        .post("/criarExcecao", payload)
        .then((res) => res);

      if (response.status == 200 && response.data.affectedRows >= 1) {
        return 200;
      } else {
        return 500;
      }
    } catch (error) {
      return 500;
    }
  }

  async updateFunctionUser(payload) {
    try {
      let response = await axios
        .post("/updateFuncaoUser", payload)
        .then((res) => res);
      if (response.status == 200 && response.data.affectedRows >= 1) {
        return 200;
      } else {
        return 500;
      }
    } catch (error) {
      return 500;
    }
  }
}
export default new funcoesUsuarioService();
